export const SECTION_STATUS = {
  COMPLETE: "complete",
  INCOMPLETE: "incomplete",
  NOT_STARTED: "not_started",
};

export const computeSectionStatuses = (ctx) => {
  const {
    completedUnlockOrder,
    visibleSections = [],
    touchedSections = {},
  } = ctx;

  const progress = Number(completedUnlockOrder) || 1;
  const statuses = {};

  visibleSections.forEach((section) => {
    const order = section.unlockOrder || 1;

    if (progress > order) {
      statuses[section.id] = SECTION_STATUS.COMPLETE;
      return;
    }

    if (progress === order) {
      statuses[section.id] = touchedSections[section.id]
        ? SECTION_STATUS.INCOMPLETE
        : SECTION_STATUS.NOT_STARTED;
      return;
    }

    statuses[section.id] = SECTION_STATUS.NOT_STARTED;
  });

  return statuses;
};

export const statusIcon = (status) => {
  switch (status) {
    case SECTION_STATUS.COMPLETE:
      return "✓";
    case SECTION_STATUS.INCOMPLETE:
      return "⚠";
    default:
      return "○";
  }
};
